<!--
	作者：1764635606@qq.com
	时间：2018-09-26
	描述：对dropdown中级联复用块封装
	
	props:
       trigger:        触发方式，默认为‘click’
       title:          打开级联项的文字
       name:           item上绑定的值
       placement:      下拉菜单出现的位置
       disabled:       是否禁用
       list:           内容数组
-->
<template>
    <Dropdown class="bp-dropdown-menu" trigger="click" :placement="placement">
        <DropdownItem :disabled="disabled" :name="name">
            <Icon type="ios-arrow-left" v-if="orientation === 'left'"></Icon>
            {{title}}
            <Icon type="ios-arrow-up" v-if="orientation === 'up'"></Icon>
            <Icon type="ios-arrow-right" v-if="orientation === 'right'"></Icon>
            <Icon type="ios-arrow-down" v-if="orientation === 'down'"></Icon>
        </DropdownItem>
        <DropdownMenu slot="list">
            <template v-for="item in list">
                <BPDropdownCasc :list="item.children" :title="item.label" :name="item.value" v-if="item.children"></BPDropdownCasc>
                <DropdownItem :name="item.value" :key="item.value" :disabled="item.disabled" v-else>{{item.label}}</DropdownItem>
            </template>
        </DropdownMenu>
    </Dropdown>
</template>

<script>
    export default {
        props: {
            list: {
                type: [Array, Object]
            },
            title: {},
            name: {},
            placement: {
                type: String
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            orientation () {
                let result = 'down'
                if (this.placement) {
                    let str = this.placement.toString()
                    if (str.indexOf('top') !== -1) {
                        result = 'up'
                    }
                    if (str.indexOf('bottom') !== -1) {
                        result = 'down'
                    }
                    if (str.indexOf('left') !== -1) {
                        result = 'left'
                    }
                    if (str.indexOf('right') !== -1) {
                        result = 'right'
                    }
                }
                return result
            }
        },
        data () {
            return {
                
            }
        }
    }
</script>

<style lang="less">
</style>